export default "__VITE_ASSET__bef41b63__"